export default __webpack_public_path__ + "static/media/OpenDyslexic-Bold.7b97cc09.ttf";